import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ModuleNameService {



  url = environment.serverAPI9 + "/api/moduleName";

  constructor(private http: HttpClient) { }

  getAllModuleName(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllModuleNameDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getModuleNameById(moduleNameId: number): Observable<Object> {
    return this.http.get(`${this.url}/${moduleNameId}`);
  }

  addOrEditModuleName(moduleName: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/list`, moduleName);
  }

  moduleNameSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  deleteByModuleNameId(moduleNameId: any): Observable<Object> {
    return this.http.delete(`${this.url}/${moduleNameId}`);
  }

  syncData() {
    return this.http.get(`${this.url}/sync`);
  }
}
